module.exports = __webpack_public_path__ + "static/media/logowordmarkwhite.0fbf6f5c.png";